var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHorGreenCsps(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 186.5 8.8",
    style: {
      enableBackground: "new 0 0 186.5 8.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#528918;}\n\t.st1{fill:#9CB6B7;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000002351685639177952800000010945180776708945823_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_03.Dotted-lines"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.6,
    y: 0.1,
    className: "st0",
    width: 185.9,
    height: 8.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M186.5,8.8h-14.4V0.1h14.4V8.8z M157.8,8.8h-14.4V0.1h14.4V8.8z M129.1,8.8h-14.4V0.1h14.4V8.8z M100.4,8.8 H86V0.1h14.4V8.8z M71.7,8.8H57.3V0.1h14.4V8.8z M43,8.8H28.6V0.1H43V8.8z M14.3,8.8H-0.1V0.1h14.4V8.8z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHorGreenCsps);
export default __webpack_public_path__ + "static/media/Hor-green-CSPS.19333ab1380480b9e04105e42aef53fd.svg";
export { ForwardRef as ReactComponent };